import { FieldKey, FORM_CONFIG as ZOOM_FORM_CONFIG } from '../connection-zoom-form.config';
import { buildConfigList } from '../../../../../../../../infrastructure/utils/form-config.utils';
import { ConnectionType, WebinarAutoRecording } from '../../../../../../../../api/connections.dao';

/* Zoom Webinar specific form config */
export const ZOOM_WEBINAR_FORM_CONFIG = {
    ...ZOOM_FORM_CONFIG,
    [FieldKey.TYPE]: {
        labelDescriptor: { id: 'oe.templates.connection.type', defaultMessage: 'Connection Type', description: 'Label text' },
        defaultValue: ConnectionType.Webinar,
        readOnly: true
    },
    [FieldKey.AUTO_RECORDING]: {
        defaultValue: WebinarAutoRecording.Cloud
    },
    [FieldKey.PANELIST_LINK_CREATION_ENABLED]: {
        defaultValue: false
    }
};

export const zoomWebinarConfigList = buildConfigList(ZOOM_WEBINAR_FORM_CONFIG);
